import React from 'react'

export default function Faq() {
    return (
        <div>
            FAQ page
        </div>
    )
}
